<template>
    <b-modal ref="mdlEditPrestazioneAmbulatoriale" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <b-row>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Codice Prestazione</label>
                <b-form-input v-model="jsonDataPrestazioneAmbulatoriale.codicePrestazione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Codice Offering</label>
                <b-form-input v-model="jsonDataPrestazioneAmbulatoriale.codiceOffering"></b-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Tipo</label>
                <b-form-input v-model="jsonDataPrestazioneAmbulatoriale.tipo"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Descrizione</label>
                <b-form-input v-model="jsonDataPrestazioneAmbulatoriale.descrizione"></b-form-input>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button @click="onCloseModal" variant="outline-danger" size="md">Annulla</b-button>
            <b-button @click="onSavePrestazioneAmbulatoriale" variant="outline-success" size="md">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            pathResource: "/rsaprestazioniambulatoriali",
            jsonDataPrestazioneAmbulatoriale: {
                id: null,
                codicePrestazione: null,
                codiceOffering: null,
                tipo: null,
                descrizione: null,
            },
        };
    },
    methods: {
        show(jsonData) {
            let me = this;
            me.jsonDataPrestazioneAmbulatoriale = jsonData;
            me.title = !jsonData.id ? "Nuova Prestazione Ambulatoriale" : "Aggiorna Prestazione Ambulatoriale";
            me.$refs.mdlEditPrestazioneAmbulatoriale.show();
        },
        onCloseModal() {
            let me = this;
            me.jsonDataPrestazioneAmbulatoriale = {};
            me.$refs.mdlEditPrestazioneAmbulatoriale.hide();
            me.$emit("onClose");
        },
        onSavePrestazioneAmbulatoriale() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataPrestazioneAmbulatoriale, me.prestazioneAmbulatorialeSuccessSave, me.prestazioneAmbulatorialeErrorSave);
        },
        prestazioneAmbulatorialeSuccessSave(response) {
            let me = this;
            me.$emit("savePrestazione", response);
            me.$refs.mdlEditPrestazioneAmbulatoriale.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        prestazioneAmbulatorialeErrorSave(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onDeletePrestazione(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Prestazione Ambulatoriale",
                    buttonSize: "sm",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deletePrestazione(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deletePrestazione(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deletePrestazioneSuccess, me.deletePrestazioneError);
        },
        deletePrestazioneSuccess(response) {
            let me = this;
            me.$emit("deletePrestazione", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Success",
                variant: "success",
                solid: true,
            });
        },
        deletePrestazioneError(error) {
            let me = this;
            me.$emit("deletePrestazione", error);
            me.$$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
